module.exports = __webpack_public_path__ + "img/logo-em.4534be6a.png";